import axios from '..';
import type {
  DeleteAdmissionApplyCountReqType,
  DeleteAdmissionReqType,
  GetAdmissionReqType,
  GetAdmissionsMajorsWithCountReqType,
  GetUserAdmissionsReqType,
  PatchAdmissionApplyCountReqType,
  PatchAdmissionReqType,
  PatchAdmissionSeasonReqType,
  PatchUserAdmissionsReqType,
  PostAdmissionApplyCountReqType,
  PostAdmissionCompetitiveUnitReqType,
  PostAdmissionReqType,
  PostUserAdmissionsReqType,
  PutAdmissionsMajorsWithCountReqType,
} from './req';
import type {
  DeleteAdmissionResType,
  GetAdmissionApplyCountResType,
  GetAdmissionResType,
  GetAdmissionSeasonResType,
  GetAdmissionsMajorsWithCountResType,
  GetUserAdmissionsAdmissionsResType,
  GetUserAdmissionsResType,
  PatchAdmissionApplyCountResType,
  PatchAdmissionResType,
  PatchAdmissionSeasonResType,
  PostAdmissionApplyCountResType,
  PostAdmissionResType,
  PostUserAdmissionsResType,
  PutAdmissionsMajorsWithCountResType,
} from './res';

export const getUserAdmissions = (body: GetUserAdmissionsReqType) => {
  const url = new URL(`${axios.getUri()}/user-admissions`);
  Object.entries(body).forEach(([key, value]) => url.searchParams.append(key, String(value)));
  return axios.get<GetUserAdmissionsResType>(url.href).then((res) => res.data);
};

// 모의지원
export const postUserAdmissions = (body: PostUserAdmissionsReqType) =>
  axios.post<PostUserAdmissionsResType>('/user-admissions', body).then((res) => res.data);

export const deleteUserAdmissions = (userAdmissionId: string) =>
  axios.delete(`/user-admissions/${userAdmissionId}`).then((res) => res.data);

export const patchUserAdmissions = (userAdmissionId: string, body: PatchUserAdmissionsReqType) =>
  axios.patch(`/user-admissions/${userAdmissionId}`, body).then((res) => res.data);

export const getUserAdmissionsAdmissions = () =>
  axios
    .get<GetUserAdmissionsAdmissionsResType>(`/user-admissions/admissions`)
    .then((res) => res.data);

export const getAdmissionsMajorsWithCount = (body: GetAdmissionsMajorsWithCountReqType) => {
  const url = new URL(`${axios.getUri()}/admissions/major`);
  Object.entries(body).forEach(([key, value]) => url.searchParams.append(key, String(value)));
  return axios.get<GetAdmissionsMajorsWithCountResType>(url.href).then((res) => res.data);
};

export const putAdmissionsMajorsWithCount = (
  admissionId: string,
  body: PutAdmissionsMajorsWithCountReqType,
) => {
  const url = new URL(`${axios.getUri()}/admissions/${admissionId}`);
  Object.entries(body).forEach(([key, value]) => url.searchParams.append(key, String(value)));
  return axios.patch<PutAdmissionsMajorsWithCountResType>(url.href).then((res) => res.data);
};

export const admission = {
  get: (params?: GetAdmissionReqType) =>
    axios.get<GetAdmissionResType>('/admissions', { params }).then((res) => res.data),
  post: (body: PostAdmissionReqType) =>
    axios.post<PostAdmissionResType>('/admissions', body).then((res) => res.data),
  patch: ({ admissionId, ...body }: PatchAdmissionReqType) =>
    axios.patch<PatchAdmissionResType>(`/admissions/${admissionId}`, body).then((res) => res.data),
  delete: ({ admissionId }: DeleteAdmissionReqType) =>
    axios.delete<DeleteAdmissionResType>(`/admissions/${admissionId}`).then((res) => res.data),
};

export const admissionApplyCountApi = {
  get: async () =>
    (await axios.get<GetAdmissionApplyCountResType>('/user-admissions/apply-count')).data,

  post: async (body: PostAdmissionApplyCountReqType) =>
    (await axios.post<PostAdmissionApplyCountResType>('/user-admissions/apply-count', body)).data,

  patch: async (body: PatchAdmissionApplyCountReqType) =>
    (await axios.patch<PatchAdmissionApplyCountResType>('/user-admissions/apply-count', body)).data,

  delete: async ({ id }: DeleteAdmissionApplyCountReqType) =>
    (await axios.delete<DeleteAdmissionResType>(`/user-admissions/apply-count/${id}`)).data,
};

export const admissionCompetitiveUnit = {
  patch: ({ admissionId, ...body }: PostAdmissionCompetitiveUnitReqType) =>
    axios.patch(`/admissions/${admissionId}/competitive-units`, body).then((res) => res.data),
};

export const admissionSeasonApi = {
  get: () => axios.get<GetAdmissionSeasonResType>('/admissions/season').then((res) => res.data),

  patch: (body: PatchAdmissionSeasonReqType) =>
    axios.patch<PatchAdmissionSeasonResType>('/admissions/season', body).then((res) => res.data),
};
